var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Expose, Type } from 'class-transformer';
import { IsArray, IsBoolean, IsDateString, IsOptional, IsString, ValidateNested, } from 'class-validator';
import { IsWithinCalendarHorizon } from '../validators/calendar-horizon.js';
import { UpdateExerciseProgramItemDto } from './update-exercise-program-item.dto.js';
export class UpdateExerciseProgramDto {
    exerciseProgramItems;
    trainingIsOnMonday;
    trainingIsOnTuesday;
    trainingIsOnWednesday;
    trainingIsOnThursday;
    trainingIsOnFriday;
    trainingIsOnSaturday;
    trainingIsOnSunday;
    startDate = new Date();
    endDate;
    /**
     * Optional free-text "Information für den Patienten" for this update. When set,
     * it is stored as a new program message and surfaced in the update
     * notification + email.
     */
    patientMessage;
}
__decorate([
    IsArray(),
    Type(() => UpdateExerciseProgramItemDto),
    ValidateNested({ each: true }),
    Expose(),
    __metadata("design:type", Array)
], UpdateExerciseProgramDto.prototype, "exerciseProgramItems", void 0);
__decorate([
    IsBoolean(),
    Expose(),
    __metadata("design:type", Boolean)
], UpdateExerciseProgramDto.prototype, "trainingIsOnMonday", void 0);
__decorate([
    IsBoolean(),
    Expose(),
    __metadata("design:type", Boolean)
], UpdateExerciseProgramDto.prototype, "trainingIsOnTuesday", void 0);
__decorate([
    IsBoolean(),
    Expose(),
    __metadata("design:type", Boolean)
], UpdateExerciseProgramDto.prototype, "trainingIsOnWednesday", void 0);
__decorate([
    IsBoolean(),
    Expose(),
    __metadata("design:type", Boolean)
], UpdateExerciseProgramDto.prototype, "trainingIsOnThursday", void 0);
__decorate([
    IsBoolean(),
    Expose(),
    __metadata("design:type", Boolean)
], UpdateExerciseProgramDto.prototype, "trainingIsOnFriday", void 0);
__decorate([
    IsBoolean(),
    Expose(),
    __metadata("design:type", Boolean)
], UpdateExerciseProgramDto.prototype, "trainingIsOnSaturday", void 0);
__decorate([
    IsBoolean(),
    Expose(),
    __metadata("design:type", Boolean)
], UpdateExerciseProgramDto.prototype, "trainingIsOnSunday", void 0);
__decorate([
    IsDateString(),
    IsOptional(),
    Expose(),
    __metadata("design:type", Date)
], UpdateExerciseProgramDto.prototype, "startDate", void 0);
__decorate([
    IsDateString(),
    IsWithinCalendarHorizon(),
    IsOptional(),
    Expose(),
    __metadata("design:type", Object)
], UpdateExerciseProgramDto.prototype, "endDate", void 0);
__decorate([
    IsString(),
    IsOptional(),
    Expose(),
    __metadata("design:type", Object)
], UpdateExerciseProgramDto.prototype, "patientMessage", void 0);
//# sourceMappingURL=update-exercise-program.dto.js.map